module.exports = __webpack_public_path__ + "static/media/computer_inr_v2.a6019ce7.svg";